/* eslint-disable react/no-array-index-key */
/* eslint-disable no-param-reassign */
/* eslint-disable import/no-unresolved */
import React from 'react'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import Button from '@material-ui/core/Button'
import Skeleton from '@material-ui/lab/Skeleton'
import Divider from '@material-ui/core/Divider'
import CachedIcon from '@material-ui/icons/Cached'

import Typography from '@material-ui/core/Typography'
import Slider from '@material-ui/core/Slider'
import { Grid } from '@material-ui/core'
import { useStyles } from './styles'

function valuetext(value) {
  return `${value}°C`
}

const ResumCommentsList = ({
  gp3Comments,
  onChangeTemperature,
  temperature,
  handleForzeCommets,
}) => {
  const classes = useStyles()
  return (
    <>
      {!gp3Comments.loading ? (
        <>
          <Typography id="discrete-slider" gutterBottom>
            Temperature
          </Typography>
          <Grid container direction="row" alignItems="center">
            <Grid item sm={9}>
              <Slider
                defaultValue={0.5}
                getAriaValueText={valuetext}
                aria-labelledby="discrete-slider"
                valueLabelDisplay="auto"
                value={temperature}
                onChangeCommitted={onChangeTemperature}
                step={0.1}
                marks
                min={0}
                max={1}
              />
            </Grid>
            <Grid item sm={3}>
              <div className={classes.justify}>
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={handleForzeCommets}
                  startIcon={<CachedIcon />}
                >
                  Reload
                </Button>
              </div>
            </Grid>
          </Grid>
          <List id="lista" dense component="div" key="key">
            {gp3Comments?.gp3Coment?.map((item, i) => (
              <div key={i}>
                <ListItem alignItems="flex-start">
                  <ListItemText className={classes.inline} primary={item} />
                </ListItem>
                <Divider />
              </div>
            ))}
          </List>
        </>
      ) : (
        <div>
          <Skeleton />
          <Skeleton animation={false} />
          <Skeleton animation="wave" />
        </div>
      )}
    </>
  )
}

export default ResumCommentsList
